import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { Reveal } from "../components/Reveal";
import { SEO } from "../components/SEO";

export default function Faq() {
  const { t } = useLanguage();
  const [open, setOpen] = useState(0);
  const items = t("faq.items");
  return (
    <div data-testid="faq-page">
      <SEO title="FAQ — The Nice Picnic, Luxury Picnics Nice & French Riviera"
        description="Everything about The Nice Picnic experiences: secret locations, booking, payment, personalisation, weather and private events on the French Riviera." />
      <section className="pt-36 pb-24 sm:pb-32 max-w-3xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center">
          <p className="overline-label">{t("faq.overline")}</p>
          <h1 className="font-serif text-4xl sm:text-5xl text-ink mt-4">{t("faq.title")}</h1>
          <div className="w-16 h-px bg-gold mt-6 mx-auto" />
        </Reveal>
        <div className="mt-14 divide-y divide-champagne border-y border-champagne">
          {items.map((item, i) => (
            <Reveal key={i} delay={i * 0.04}>
              <button data-testid={`faq-question-${i}`} onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-6 py-6 text-left">
                <span className="font-serif text-xl sm:text-2xl text-ink">{item.q}</span>
                <ChevronDown size={18} className={`text-terracotta shrink-0 transition-transform duration-300 ${open === i ? "rotate-180" : ""}`} />
              </button>
              <div className={`overflow-hidden transition-all duration-500 ${open === i ? "max-h-60 pb-6" : "max-h-0"}`}>
                <p data-testid={`faq-answer-${i}`} className="text-earth font-light leading-relaxed">{item.a}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
